import { render } from "./BlogPromoBanner.vue?vue&type=template&id=e4a049b4"
import script from "./BlogPromoBanner.vue?vue&type=script&lang=js"
export * from "./BlogPromoBanner.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__